import CONSTANTES from '../constantes';
import { takeEvery, call, put } from 'redux-saga/effects'
import { message } from 'antd'
import moment from 'moment'
import { actionGetFilesProductSuccess } from '../acciones/accionesProductos';
const axios = require('axios');


const getFilesProduct = (idProducto) => axios({
    method: 'GET',
    url: `${CONSTANTES.URL_API}/sellers/image_products/?search=${idProducto}`,
    headers: {
        'Content-Type': 'application/json'
    }
})
    .then(response => response)
    .catch(error => error.response)


function* sagasGetFilesProduct(values) {
    try {
        const response = yield call(getFilesProduct, values.idProduct);
        if(response.status===200){      
            let arrayFiles=[]
            response.data.filter(itemFiltered=>itemFiltered.producto===values.idProduct).forEach(item=>{
                arrayFiles.push({
                    uid:item.id,
                    name: `file_${item.producto}`,
                    status:'done',
                    url:item.image_product,
                    idProducto:item.producto
                })
            })
            yield put(actionGetFilesProductSuccess(arrayFiles))
        }
    } catch (error) {
        console.log('error',error)
    }
}



export default function* SagasFileProduct() {
    yield takeEvery(CONSTANTES.GET_FILES_PRODUCTS_REQUEST, sagasGetFilesProduct)
}